__turbopack_context__.v({
  "blackBurger": "Header-module-scss-module__yUQ6Nq__blackBurger",
  "blackOnTransparent": "Header-module-scss-module__yUQ6Nq__blackOnTransparent",
  "headerBox": "Header-module-scss-module__yUQ6Nq__headerBox",
  "headerBtn": "Header-module-scss-module__yUQ6Nq__headerBtn",
  "headerBurgerMenu": "Header-module-scss-module__yUQ6Nq__headerBurgerMenu",
  "headerContainer": "Header-module-scss-module__yUQ6Nq__headerContainer",
  "headerContainer__white": "Header-module-scss-module__yUQ6Nq__headerContainer__white",
  "headerNavItem": "Header-module-scss-module__yUQ6Nq__headerNavItem",
  "headerNavMenu": "Header-module-scss-module__yUQ6Nq__headerNavMenu",
  "multiOnTransparent": "Header-module-scss-module__yUQ6Nq__multiOnTransparent",
  "svgClass": "Header-module-scss-module__yUQ6Nq__svgClass",
  "whiteBurger": "Header-module-scss-module__yUQ6Nq__whiteBurger",
  "whiteOnTransparent": "Header-module-scss-module__yUQ6Nq__whiteOnTransparent",
});
